import React from 'react';
import { useSelectedSlide } from '@components/Presentation/hooks/useSelectedSlide';
import Switch from '@molecules/Switch';
import { QuestionIcon } from '@phosphor-icons/react';
import Tooltip from '@components/Presentation/atoms/Tooltip';
import { type InteractionSettings } from '@components/Presentation/types';

function ShowProfilePictures({ settingKey }: { settingKey: keyof InteractionSettings }) {
  const selectedSlide = useSelectedSlide();
  return (
    <div className="flex">
      <div className="flex flex-1 text-sm flex-nowrap">
       Display profile pictures &nbsp;
        <Tooltip content="Show profile pictures to help identify participants.">
          <QuestionIcon size={20}

            className='!text-default-400'
          />
        </Tooltip>
      </div>
      <Switch
        checked={!!selectedSlide?.setting?.[settingKey]}
        onChange={(e) =>
          selectedSlide.handler.updateSetting(
            settingKey,
            e.target.checked
          )
        }
        onClick={() => {}}
      />
    </div>
  );
}

export default ShowProfilePictures;
